import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const HeartIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 15),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    children: /*#__PURE__*/jsx("path", {
      d: "M12.8.8c2.3 0 4.3 2 4.3 4.4 0 1.5-1 2.8-2.1 3.8-.6.5-2.2 1.8-3.7 3-.8.6-1.5 1.1-2 1.6l-.4.3-.4-.3c-.5-.4-1.3-1-2-1.6C5 10.8 3.3 9.5 2.8 9 1.7 8 .7 6.7.7 5.2.8 2.7 2.7.8 5 .8s2.7.9 3.2 2c.2.4.6.5 1 .3.2 0 .3-.2.3-.4.2-.5.7-1 1.3-1.3.6-.4 1.3-.6 1.9-.6Z"
    })
  });
};

export { HeartIcon };
//# sourceMappingURL=heart.js.map
